// import { Formik, Form, Field, useFormikContext } from 'formik';
// import { Table,Container } from 'reactstrap'
// import { useTable } from 'react-table';



// export function AttatchFileForContactComponent () {
//     const columns = [
//         {
//           Header: 'Name',
//           accessor: 'name',
//           Cell: ({ row }) => {
//             const { values } = useFormikContext();
//             return <Field name={`data[${row.index}].name`} value={values.data[row.index].name} />;
//           },
//         },
//         {
//           Header: 'Email',
//           accessor: 'email',
//           Cell: ({ row }) => {
//             const { values } = useFormikContext();
//             return <Field name={`data[${row.index}].email`} value={values.data[row.index].email} />;
//           },
//         },
//         {
//           Header: 'FirstName',
//           accessor: 'firstName',
//           Cell: ({ row }) => {
//             const { values } = useFormikContext();
//             return <Field name={`data[${row.index}].firstName`} value={values.data[row.index].firstName} />;
//           },
//         },
//         {
//           Header: 'LastName',
//           accessor: 'lastName',
//           Cell: ({ row }) => {
//             const { values } = useFormikContext();
//             return <Field name={`data[${row.index}].lastName`} value={values.data[row.index].lastName} />;
//           },
//         },
//         {
//           Header: 'test',
//           accessor: 'test',
//           Cell: ({ row }) => {
//             const { values } = useFormikContext();
//             return <Field name={`data[${row.index}].test`} value={values.data[row.index].test} />;
//           },
//         },
//         {
//             Header: 'merge',
//             columns:[
//                 {
//                     Header: 'test1',
//                     accessor: 'test1',
//                     Cell: ({ row }) => {
//                       const { values } = useFormikContext();
//                       return <Field name={`data[${row.index}].test1`} value={values.data[row.index].test1} />;
//                     },
//                 },
//                 {
//                     Header: 'test2',
//                     accessor: 'test2',
//                     Cell: ({ row }) => {
//                       const { values } = useFormikContext();
                      
//                       return <Field name={`data[${row.index}].test2`} value={values.data[row.index].test2} />;
//                     },
//                 },
//             ]
//         },
        
//     ];
//   const initialValues = {
//     data: [
     
//       {
//         name: '',
//         email: '',
//         firstName:"",
//         lastName:"",
//         test:"",
//         test1:"",
//         test2:"",
//       },
//     ],
//   };

//   const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
//     columns,
//     data: initialValues.data,
//   });

//   return (
//     <Formik 
//         initialValues={initialValues} 
//         onSubmit={(values) => console.log(values)}
//         >
//             <Container>
//                 <Form>
//                     <div style={{ overflowX: 'auto' }}>
//                         <Table {...getTableProps()} hover responsive style={{ backgroundColor: '#FFFFFF' ,borderTopColor:"#ff0000"}}>
//                             <thead className='text-center' style={{verticalAlign:"top"}}>
//                                 {headerGroups.map((headerGroup) => (
//                                 <tr {...headerGroup.getHeaderGroupProps()}>
//                                     {headerGroup.headers.map((column) => (
//                                     <th {...column.getHeaderProps()}>{column.render('Header')}</th>
//                                     ))}
//                                 </tr>
//                                 ))}
//                             </thead>
//                             <tbody {...getTableBodyProps()}>
//                                 {rows.map((row) => {
//                                 prepareRow(row);
//                                 return (
//                                     <tr {...row.getRowProps()}>
//                                     {row.cells.map((cell) => (
//                                         <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
//                                     ))}
//                                     </tr>
//                                 );
//                                 })}
//                             </tbody>
//                         </Table>
//                     </div>
                
//                     <button type="submit">Submit</button>
//                 </Form>
//             </Container>
//     </Formik>
//   );
// };








import { Container, FormGroup, Label,Input } from "reactstrap";
import React, { useEffect, useState } from "react";
import { Loading } from "../../share/loading";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useSearchParams } from "react-router-dom";
import "../../share/form.css";
import Swal from "sweetalert2";


export function AttatchFileForContactComponent() {
    const user = JSON.parse(localStorage.getItem("userData"));
    console.log("user",user)
    const [loading, setLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const [data, setData] = useState([]);
    const borrowId = searchParams.get("req")
    // console.log("foundValue",foundValue)
    // console.log("data",data)
    // console.log("borrowId =>",borrowId)

   

    const formInitialValues ={
        fMarriageCertificate:"",
        fSpouseIdCard:"",
        borrowId : borrowId,
    }

    const validateSchema = Yup.object().shape({
      fMarriageCertificate:Yup.mixed().test('fileFormat','กรุณาแนบไฟล์ประเภท pdf, jpg, jpeg ', (value) => {
            return value && ['application/pdf','image/jpg','image/jpeg'].includes(value.type)
          }).test('fileSize','ขนาดไฟล์ต้องไม่เกิน 1MB', (value) => {
            const maxSize = 1000000;
            return !value || (value.size <= maxSize);
          }),
      fSpouseIdCard: Yup.mixed().test('fileFormat','กรุณาแนบไฟล์ประเภท pdf, jpg, jpeg ', (value) => {
            return value && ['application/pdf','image/jpg','image/jpeg'].includes(value.type)
          }).test('fileSize','ขนาดไฟล์ต้องไม่เกิน 1MB', (value) => {
            const maxSize = 1000000;
            return !value || (value.size <= maxSize);
          })
    })

    const onSubmit = async(values) => {
        console.log(values)
        setLoading(true)
        try{
            let postData = new FormData();
            postData.append("",)
            postData.append("",)
            // let res = await fetch(`api/ContactBorrow/saveSignContact`,{
            //     method: "POST",
            //     headers: { "Content-type": "application/json" },
            //     body: JSON.stringify(values),
            // })
            // let resJson = await res.json();
            // if(resJson.status === 1){
            //     Swal.fire({
            //         icon: "success",
            //         title: "บันทึกข้อมูลสำเร็จ",
            //         text: "",
            //         confirmButtonColor: "#0A66C2",
            //         confirmButtonText: "ตกลง",
            //     })
            // }
        }catch(e){
            console.log(e)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Formik
            initialValues={formInitialValues}
            validationSchema={validateSchema}
            onSubmit={onSubmit}
            enableReinitialize
            >
                {({setFieldValue, errors, touched, values, handleChange, handleBlur}) => {
                    // console.log("values",values)
                    // console.log("errors", errors)
                    // console.log(errors)
                    return(
                        <Container className="d-flex flex-column justify-content-center align-items-center mb-5">
                            {loading ? (

                                <Loading/>

                            ): (
                                <div style={{maxWidth:"850px",width:"100%"}} className="d-flex flex-column justify-content-center align-items-center w-100">
                                   
                                    <div className="form-border">
                                        <Form autoComplete="off">

                                            <div className="p-5">
                                                <div className="d-flex justify-content-center align-items-center mb-3 mt-4">
                                                    <Label className="w-50">ทะเบียนสมรส: </Label>
                                                     <Input
                                                            id="fMarriageCertificate"
                                                            name="fMarriageCertificate"
                                                            type="file"
                                                            className={
                                                                  touched.fMarriageCertificate && errors.fMarriageCertificate
                                                                  ? "input-error rounded-pill text-center input-color"
                                                                  : "rounded-pill text-center input-color"
                                                            }
                                                            onBlur={handleBlur}
                                                            onChange={(e) => {
                                                                  handleChange(e);
                                                                  if (e.target && e.target.files[0]) {
                                                                  setFieldValue("fMarriageCertificate", e.target.files[0]);
                                                                  }
                                                            }}
                                                      />
                                                </div>

                                                <div className="d-flex justify-content-center align-items-center mb-3 mt-4">
                                                    <Label className="w-50">สำเนาบัตรประชาชนคู่สมรส: </Label>
                                                    <Input
                                                            id="fSpouseIdCard"
                                                            name="fSpouseIdCard"
                                                            type="file"
                                                            className={
                                                                  touched.fSpouseIdCard && errors.fSpouseIdCard
                                                                  ? "input-error rounded-pill text-center input-color"
                                                                  : "rounded-pill text-center input-color"
                                                            }
                                                            onBlur={handleBlur}
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                                if (e.target && e.target.files[0]) {
                                                                setFieldValue("fSpouseIdCard", e.target.files[0]);
                                                                }
                                                            }}
                                                      />
                                                </div>
                                          
                                                <FormGroup className="d-flex justify-content-center align-items-center mt-3">
                                                      <button type="submit" className="btn-blue w-25 mt-3">บันทึก</button>
                                                </FormGroup>
                                            </div>
                                        
                                        </Form>
                                    </div>
                                </div>
                               
                            )}
                        
                        </Container>
                    )

                }}
        </Formik>

    )
}